import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { ExclusionTime } from '../../../shared/definitions';
import styles from '../../../shared.scss';
import { ExclusionType } from '../../definitions';
import type { ExclusionResponseProps as Props } from '../../definitions';
import useLogoutUser from '../../hooks/useLogoutUser';
import DefaultBreakResponse from '../DefaultBreakResponse/DefaultBreakResponse';

import {
  TXTCLI_Logout,
  TXTWCL_Any_remaining_funds_will_be_au_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_6,
  TXTWCL_This_means_your_account_is_clo_ELL_1,
  TXTWCL_YouXll_be_able_to_request_to_r_ELL_2
} from './ExclusionResponseCAON.messages.json';

const ExclusionResponseCAON: React.FC<Props> = ({ daysRequested, exclusionType, endDate }) => {
  const logoutUser = useLogoutUser();

  const indefiniteExclusion = daysRequested === ExclusionTime.Indefinite;

  if (exclusionType === ExclusionType.Break) {
    return <DefaultBreakResponse daysRequested={daysRequested} endDate={endDate} />;
  }

  return (
    <div>
      {indefiniteExclusion ? (
        <>
          <Translation {...TXTWCL_This_means_your_account_is_clo_ELL_1} />
          <Translation tagName="p" {...TXTWCL_Any_remaining_funds_will_be_au_ELL} />
        </>
      ) : (
        <>
          <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_6} />{' '}
          <Translation
            {...TXTWCL_YouXll_be_able_to_request_to_r_ELL_2}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      )}
      <StarsButton
        block
        translation={TXTCLI_Logout}
        className={styles.logoutButton}
        onClick={logoutUser}
      />
    </div>
  );
};

export default ExclusionResponseCAON;
